import { render, staticRenderFns } from "./whatsNew.vue?vue&type=template&id=544d8ffa&"
import script from "./whatsNew.vue?vue&type=script&lang=js&"
export * from "./whatsNew.vue?vue&type=script&lang=js&"
import style0 from "./whatsNew.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports